import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "passwordRequirements" }
const _hoisted_2 = { id: "title" }
const _hoisted_3 = { class: "requirementsList" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = {
  key: 5,
  class: "error"
}
const _hoisted_6 = {
  key: 6,
  class: "error"
}

import { computed } from "vue";
import { useI18n } from 'vue-i18n';

export interface WachtwoordRequirements {
  minimumLength: number,
  includeCapital: boolean,
  includeNumber: boolean,
  includeSymbol: boolean,
  forbiddenUserInfo: string[],
}

export interface VerificationResult {
  IsValid: boolean,
  Message: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordRequirementsChecker',
  props: {
  wachtwoordRequirements: {
    type: Object as () => WachtwoordRequirements,
    required: true
  },
  currentPassword: String,
  newPassword: {
    type: String,
    required: true,
  },
  newPasswordConfirm: {
    type: String,
    required: true,
  },
  checkMatchingCurrentNew: {
    type: Boolean,
    default: false
  },
  checkNewPaswswordConfirmed: {
    type: Boolean,
    default: true
  }
},
  setup(__props, { expose: __expose }) {

const props = __props;

__expose({
  verify,
})

const { t } = useI18n();
const passedLengthRequirement = computed<boolean>(() => props.newPassword.length >= props.wachtwoordRequirements.minimumLength);
const passedCapitalRequirement = computed<boolean>(() => /[A-Z]/.test(props.newPassword));
const passedNumberRequirement = computed<boolean>(() => /[0-9]/.test(props.newPassword));
const passedSymbolRequirement = computed<boolean>(() => /[-!"#$%&'()*+,./:;<=>?@\[\]^_`{|}~]/.test(props.newPassword));
const containsUserData = computed<boolean>(() => {
  const loweredPassword = props.newPassword.toLowerCase();
  const containsUserdata = props.wachtwoordRequirements.forbiddenUserInfo.some(fv => loweredPassword.includes(fv));
  return containsUserdata;
});
const currentPasswordMatchingNew = computed<boolean>(() => {
  return props.checkMatchingCurrentNew && props.currentPassword!.length > 0 && props.newPassword.length > 0 && props.currentPassword === props.newPassword
})
const newPasswordConfirmed = computed<boolean>(() => !props.checkNewPaswswordConfirmed || props.newPassword === props.newPasswordConfirm)


function verify(): VerificationResult
{
  let messages: string[] = [];
  let verificationResult = { IsValid: true, Message: '' };

  if (props.wachtwoordRequirements.minimumLength && !passedLengthRequirement.value)
    messages.push(t('errors.minLength', { aantal: props.wachtwoordRequirements.minimumLength }));

  if (props.wachtwoordRequirements.includeCapital && !passedCapitalRequirement.value)
    messages.push(t('errors.includeCapital'));

  if (props.wachtwoordRequirements.includeNumber && !passedNumberRequirement.value)
    messages.push(t('errors.includeNumber'));

  if (props.wachtwoordRequirements.includeSymbol && !passedSymbolRequirement.value)
    messages.push(t('errors.includeSymbol'));

  if (containsUserData.value)
    messages.push(t('errors.cantContainUserData'));

  if (currentPasswordMatchingNew.value)
    messages.push(t('errors.passwordsTheSame'))

  if (!newPasswordConfirmed.value)
    messages.push(t('errors.passwordsMustMatch'))

    
  if (messages.length) {
    verificationResult.IsValid = false;
    verificationResult.Message = '<ul>'
    messages.forEach(m => {
      verificationResult.Message += '<li>' + m + '</li>';
    })
    verificationResult.Message += '</ul>'
  }

  return verificationResult;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('labels.title')), 1),
    _createElementVNode("ul", _hoisted_3, [
      (containsUserData.value)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, _toDisplayString(_unref(t)('errors.cantContainUserData')), 1))
        : _createCommentVNode("", true),
      (__props.wachtwoordRequirements.minimumLength)
        ? (_openBlock(), _createElementBlock("li", {
            key: 1,
            class: _normalizeClass({passed: passedLengthRequirement.value})
          }, _toDisplayString(_unref(t)('labels.minLength', {aantal: __props.wachtwoordRequirements.minimumLength})), 3))
        : _createCommentVNode("", true),
      (__props.wachtwoordRequirements.includeCapital)
        ? (_openBlock(), _createElementBlock("li", {
            key: 2,
            class: _normalizeClass({passed: passedCapitalRequirement.value})
          }, _toDisplayString(_unref(t)('labels.includeCapital')), 3))
        : _createCommentVNode("", true),
      (__props.wachtwoordRequirements.includeNumber)
        ? (_openBlock(), _createElementBlock("li", {
            key: 3,
            class: _normalizeClass({passed: passedNumberRequirement.value})
          }, _toDisplayString(_unref(t)('labels.includeNumber')), 3))
        : _createCommentVNode("", true),
      (__props.wachtwoordRequirements.includeSymbol)
        ? (_openBlock(), _createElementBlock("li", {
            key: 4,
            class: _normalizeClass({passed: passedSymbolRequirement.value})
          }, _toDisplayString(_unref(t)('labels.includeSymbol')), 3))
        : _createCommentVNode("", true),
      (currentPasswordMatchingNew.value)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, _toDisplayString(_unref(t)('errors.passwordsTheSame')), 1))
        : _createCommentVNode("", true),
      (!currentPasswordMatchingNew.value && !newPasswordConfirmed.value)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, _toDisplayString(_unref(t)('errors.passwordsMustMatch')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})